module.exports = __webpack_public_path__ + "media/celebrity.acc47262.mp4";